import React from "react";

import { CampaignStatusPresetsTableActions } from "routes/campaign_status_presets/CampaignStatusPresetsTableActions";

export const getCampaignStatusPresetsTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
      size: 250,
    },
    {
      header: "Campaign Statuses",
      id: "Campaign Statuses",
      accessorKey: "info.campaign_statuses",
      enableSorting: false,
      cell: ({ row }) => {
        const value = row.original?.info?.campaign_statuses;
        if (value && value.length > 0) {
          return value.map(({ name }) => name).join(", ");
        }
        return "--";
      },
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <CampaignStatusPresetsTableActions original={row.original} />
      ),
    },
  ];
};

export const getCampaignStatusPresetsTableFilters = () => {
  return [];
};
